import { render, staticRenderFns } from "./FriendSearchStatus.vue?vue&type=template&id=4a2d00a0&scoped=true&"
import script from "./FriendSearchStatus.vue?vue&type=script&lang=js&"
export * from "./FriendSearchStatus.vue?vue&type=script&lang=js&"
import style0 from "./FriendSearchStatus.vue?vue&type=style&index=0&id=4a2d00a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2d00a0",
  null
  
)

export default component.exports